// extracted by mini-css-extract-plugin
export default {"alert":"alert_alert__R+x5-"};